import { compose, withProps } from "recompose";
import { connect } from "react-redux";
import { decodeParam } from "react-router-utils";
import { getCart } from "app/redux/selectors";
import { getCartArticleIds } from "app/redux/modules/cart";
import MiniCart from "./MiniCart";

const mapStateToProps = state => ({
  articleIds: getCartArticleIds(getCart(state))
});

export default compose(
  withProps(({ match }) => ({
    clubId: decodeParam(match.params.clubId)
  })),
  connect(mapStateToProps)
)(MiniCart);



// WEBPACK FOOTER //
// ./src/app/components/MiniCart/MiniCartContainer.js